// extracted by mini-css-extract-plugin
module.exports = {"leftControl":"SliderControls_leftControl__V4QYG","rightControl":"SliderControls_rightControl__1Fx5P"};